import React from 'react';

import { AccessCardSkeleton } from './AccessCardSkeleton';
import { REQUEST_CARD_WIDTH } from './constants';

export function RequestCardSkeleton({ className }: { className?: string }) {
  return (
    <AccessCardSkeleton width={REQUEST_CARD_WIDTH} className={className} />
  );
}
